import { HttpRequest } from "../utils";

const httpRequest = new HttpRequest();

export interface StockTransferItem {
  variantId: string;
  qty: number;
  unit?: string | null;
  notes?: string | null;
}

export interface CreateStockTransferBody {
  fromWarehouseId: string;
  toWarehouseId: string;
  notes?: string | null;
  items: StockTransferItem[];
}

export const create = async (body: CreateStockTransferBody) => {
  return httpRequest.post("/ord/stock-transfer", body as never);
};

export const list = async (data: {
  filter?: { status?: string; fromWarehouseId?: string; toWarehouseId?: string; search?: string };
  offset?: { limit: number; skip: number };
}) => {
  return httpRequest.post("/ord/stock-transfer/list", data as never);
};

export const get = async (id: string) => {
  return httpRequest.get(`/ord/stock-transfer/${id}`);
};

export const transition = async (id: string, body: { to: string; reason?: string | null }) => {
  return httpRequest.post(`/ord/stock-transfer/${id}/transition`, body as never);
};
